// src/utils/authUtil.js
import tool from '@/utils/tool';
import publicjs from '@/api/model/publicjs';
import api from '@/api'

export default {
    /**
     * 获取并返回用户能操作的门店信息
     * @param {String} purviewId - 权限ID
     * @returns {Promise<Object>} 机构信息对象
     */
    async getOrgofPurview(purviewId) {
        // eslint-disable-next-line no-debugger
        //debugger;
        let ui = tool.data.get("USER_INFO");
        var head = new publicjs.head();
        publicjs.initHead(head, "getorgofpurview");
        var ed = new publicjs.entitydata(head);
        ed.Data.Content.ObjectList.Object.push({
            UserCode: ui.userCode,
            PurviewType: ui.currentView,
            OrgCode: ui.currentOrgCode,
            ObjName: purviewId,
        });
        try {
            var returnValueStr = await api.auth.objProcess.post(ed);
            console.log(returnValueStr);
            let returnValue = JSON.parse(returnValueStr);
            if (returnValue.Result.OpFlag == "1") {
                return {
                    orgCode: returnValue.Result.Content.OrgCode,
                    orgName: returnValue.Result.Content.OrgName,
                };
            } else {
                this.$message.error("操作失败:" + returnValue.Result.OpMsg);
            }
        } catch (error) {
            this.$alert(error.message, "提示", { type: "error" });
            return false;
        }
    },

    /**
    * 获取并返回用户在该门店(或多门店)的权限
    * @param {String} orgCode - 门店信息
    * @param {String} purviewId - 权限ID
    * @returns {Promise<Object>} 权限状态对象
    */
    async initPurview(orgCode = "", purviewId) {
        try {
            orgCode = orgCode.trim(",");
            let loginUser = tool.data.get("USER_INFO");

            // 默认权限状态
            let permissionState = {
                addState: false,
                editState: false,
                editBatchState: false,
                deleteState: false
            };

            // 如果没有门店或者多个门店，返回默认的无权限状态
            if (orgCode == "" || orgCode.indexOf(",") > 0) {
                return permissionState;
            }

            // 如果只有一个门店，调用接口查询用户权限
            var head = new publicjs.head();
            publicjs.initHead(head, "purviewbtn");
            var ed = new publicjs.entitydata(head);
            var eo = new publicjs.entityobj();
            eo.ValueList = {
                PurviewId: purviewId,
                OrgCode: orgCode,
                UserCode: loginUser.userCode,
            };
            ed.Data.Content.ObjectList.Object.push(eo);

            var returnValueStr = await api.auth.objProcess.post(ed);
            var returnValue = JSON.parse(returnValueStr);
            console.log(returnValue, 'returnValue');

            if (returnValue.Result.OpFlag == "1") {
                let btnList = returnValue.Result.Content;

                if (btnList == "all") { // 所有权限（目前只有新增、编辑、删除、查询），后面要是要加就后端接口新增，这里多返回权限回去就行
                    permissionState = {
                        addState: true,
                        editState: true,
                        editBatchState: true,
                        deleteState: true
                    };
                } else {
                    permissionState = {
                        addState: btnList.indexOf("add") >= 0,
                        editState: btnList.indexOf("edit") >= 0,
                        editBatchState: btnList.indexOf("editBatch") >= 0,
                        deleteState: btnList.indexOf("delete") >= 0
                    };
                }
            }

            return permissionState;
        } catch (error) {
            console.error("获取权限失败:", error);
            throw error;
        }
    },

    /**
     * 初始化组件的机构权限(获取此组件该用户能操作的门店并获取在该门店的权限)    这里看起来只是先取一家可用门店默认显示，门店选择组件还会重新拉取一下可用门店
     *  * @param {String} purviewId - 权限ID // component
     */
    async initComponentOrgPurview(purviewId) {
        let orgObj = {}
        let ui = tool.data.get("USER_INFO");
        try {
            // 根据用户视图类型获取机构信息
            if (ui.currentView == "0" || ui.currentView == "1") {
                let currentOrg = await this.getOrgofPurview(purviewId);
                console.log(currentOrg);

                orgObj = {
                    OrgCode: currentOrg.orgCode,
                    OrgName: currentOrg.orgName
                }
            } else {
                orgObj = {
                    OrgCode: ui.currentOrgCode,
                    OrgName: ui.currentOrgName
                }
            }
            // 初始化权限并绑定数据
            let permissionState = await this.initPurview(orgObj.OrgCode, purviewId);
            return { permissionState, orgObj }

        } catch (error) {
            alert(error.message, "提示", { type: "error" });
        } finally {

        }
    },

};